(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/game-guide-tipsen/assets/javascripts/tipsen-play.js') >= 0) return;  svs.modules.push('/components/tipsen/game-guide-tipsen/assets/javascripts/tipsen-play.js');
"use strict";


const {
  cdn
} = svs.core.config.data.svsconfig;
const {
  getDisplayName,
  getProductClassName
} = svs.utils.products;
const {
  useDefinition
} = svs.components.tipsen.engine.utils;
const {
  useRef,
  useEffect
} = React;
const productsToIncludeDrawManager = ['Topptipset', 'Powerplay'];
const gameTypesText = {
  Topptipset: '8 fotbollsmatcher',
  Powerplay: '8 hockeymatcher',
  Europatipset: '13 fotbollsmatcher',
  Stryktipset: '13 fotbollsmatcher',
  Bomben: '2 till 4 matcher',
  Fullträff: '13 fotbollsmatcher'
};
const eventTypeText = {
  default: 'Välj 1, X eller 2 . 1 betyder att hemmalaget vinner, X att det blir oavgjort och 2 att bortalaget vinner. Om du är du osäker på hur matchen slutar kan du klicka i två eller alla tre alternativ. Att välja två alternativ kallas att halvgardera och tre att helgardera.',
  Bomben: 'Välj minst ett alternativ per lag i varje match',
  Fullträff: 'Välj mellan 0, 1, 2, 3, 4, 5, 6, 7+ mål. Om du är osäker kan du klicka i flera alternativ och bygga vad som kallas för ett system.'
};
const eventTypeHeaderText = {
  Fullträff: 'Hur många mål tror du det blir i matchen?',
  default: 'Hur tror du det går i matchen?'
};
const overviewText = {
  Fullträff: 'I botten på sidan kan du se hur många matcher du tippat och priset för spelet.',
  default: 'I botten på sidan kan du se hur många matcher du tippat, antal hel- och halvgarderingar och priset för spelet.'
};
const animate = _ref => {
  let {
    topContainer,
    bottomContainer
  } = _ref;
  const initZDegree = () => "".concat(Number(gsap.utils.random(20, 90)) % 2 ? '-' : '').concat(Number(gsap.utils.random(15, 90)), "deg");
  const randomPositiveZDegree = () => "".concat(Number(gsap.utils.random(0, 30)) % 2 ? '+' : '').concat(Number(gsap.utils.random(0, 30)), "deg");
  const randomNegativeZDegree = () => "".concat(Number(gsap.utils.random(0, 25)) % 2 ? '+' : '').concat(Number(gsap.utils.random(0, 10)), "deg");
  const topIcons = topContainer.querySelectorAll('.pg_game_guide__background--img');
  const bottomIcons = bottomContainer.querySelectorAll('.pg_game_guide__background--img');
  if (topIcons.length === 0 || bottomIcons.length === 0) {
    return;
  }
  const isReducedMotionPreferred = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const tl = gsap.timeline();
  if (!isReducedMotionPreferred) {
    gsap.set([topIcons[0]], {
      y: 20,
      rotationZ: initZDegree
    });
    gsap.set([topIcons[1]], {
      y: -10,
      rotationZ: initZDegree
    });
    gsap.set([bottomIcons[0]], {
      y: 20,
      rotationZ: initZDegree
    });
    gsap.set([bottomIcons[1]], {
      y: -10,
      rotationZ: initZDegree
    });
    tl.to([topIcons, bottomIcons], {
      x: 0,
      y: 0,
      rotate: randomPositiveZDegree(),
      duration: 7,
      delay: 0.3,
      ease: 'back.out(1.4)',
      stagger: 0.3
    }).to([topIcons, bottomIcons], {
      x: -27,
      y: 12,
      rotate: randomPositiveZDegree(),
      duration: 12,
      delay: 0,
      ease: 'back.out(1.4)',
      stagger: 1.4
    }, '<').to([topIcons[0], bottomIcons[1]], {
      x: 0,
      y: 0,
      rotate: randomNegativeZDegree(),
      duration: 20,
      ease: 'back.out(1.4)',
      stagger: -1.7
    }, '<').to([topIcons[1], bottomIcons[0]], {
      x: 0,
      y: 0,
      rotate: randomPositiveZDegree(),
      duration: 20,
      ease: 'back.out(1.4)',
      stagger: -1.7
    }, '<');
  } else {
    tl.to([topIcons, bottomIcons], {
      x: 0,
      y: 0,
      rotate: 0,
      duration: 1.5,
      delay: 0,
      ease: 'back.out(1.4)',
      stagger: 0
    });
  }
};
const TipsenPlay = () => {
  var _useDefinition$drawPr, _useDefinition;
  const productId = (_useDefinition$drawPr = (_useDefinition = useDefinition()) === null || _useDefinition === void 0 || (_useDefinition = _useDefinition.drawProductIds) === null || _useDefinition === void 0 ? void 0 : _useDefinition[0]) !== null && _useDefinition$drawPr !== void 0 ? _useDefinition$drawPr : undefined;
  const topContainer = useRef(null);
  const bottomContainer = useRef(null);
  const productName = getDisplayName(productId);
  const productImgName = getProductClassName(productId);
  useEffect(() => {
    if (topContainer.current && bottomContainer.current) {
      animate({
        topContainer: topContainer.current,
        bottomContainer: bottomContainer.current
      });
    }
  }, []);
  const shouldShowDrawManager = productsToIncludeDrawManager.includes(productName);
  return React.createElement("div", {
    className: "pg_tipsen_game_guide__play-content"
  }, React.createElement("div", {
    className: "pg_game_guide__content--img-container pg_game_guide__content--img-container-top",
    ref: topContainer
  }, React.createElement("img", {
    alt: "Svenska spel",
    className: "pg_game_guide__background--img pg_game_guide__background--img-svs",
    height: 130,
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/svs-cube.svg")
  }), React.createElement("img", {
    alt: productName,
    className: "pg_game_guide__background--img pg_game_guide__background--img-product",
    height: 105,
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-cube.svg")
  })), React.createElement("div", {
    className: "pg_game_guide__content--img-container pg_game_guide__content--img-container-bottom",
    ref: bottomContainer
  }, React.createElement("img", {
    alt: productName,
    className: "pg_game_guide__background--img pg_game_guide__background--img-product",
    height: 105,
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-cube.svg")
  }), React.createElement("img", {
    alt: "Svenska spel",
    className: "pg_game_guide__background--img pg_game_guide__background--img-svs",
    height: 130,
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/svs-cube.svg")
  })), React.createElement("div", {
    className: "pg_tipsen_game_guide__play"
  }, React.createElement("h1", {
    className: "pg_tipsen_game_guide__title"
  }, "Tippa resultatet i", React.createElement("br", null), gameTypesText[productName]), shouldShowDrawManager && React.createElement(React.Fragment, null, React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-2"
  }, "1"), React.createElement("h4", {
    className: "margin-bottom-1 pg_tipsen_game_guide__img_header"
  }, "Vilken spelomg\xE5ng vill du spela?"), React.createElement("img", {
    alt: "Omg\xE5ngsv\xE4ljare f\xF6r ".concat(productName),
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-draw-manager.svg")
  }), React.createElement("p", {
    className: "margin-bottom-3"
  }, "Klicka h\xE4r f\xF6r att se alla spelomg\xE5ngar")), React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-2"
  }, shouldShowDrawManager ? 2 : 1), React.createElement("h4", {
    className: "margin-bottom-1 pg_tipsen_game_guide__img_header"
  }, eventTypeHeaderText[productName] || eventTypeHeaderText.default), React.createElement("img", {
    alt: "Match i kupongen",
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-draw-event.svg")
  }), React.createElement("p", {
    className: "margin-bottom-3"
  }, eventTypeText[productName] || eventTypeText.default), React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-2"
  }, shouldShowDrawManager ? 3 : 2), React.createElement("h4", {
    className: "margin-bottom-1 pg_tipsen_game_guide__img_header"
  }, "Vill du ha mer information och statistik om lagen?"), React.createElement("img", {
    alt: "Statistik f\xF6r matchen",
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-stats.svg")
  }), React.createElement("p", {
    className: "margin-top-2 margin-bottom-3"
  }, "Klicka p\xE5 lagnamnen s\xE5 visas mer information som till exempel statistik och spelanalys."), React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-2"
  }, shouldShowDrawManager ? 4 : 3), React.createElement("h4", {
    className: "margin-bottom-1 pg_tipsen_game_guide__img_header"
  }, "Var hittar jag information om mitt spel?"), React.createElement("img", {
    alt: "\xD6versikt f\xF6r spel",
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-overview.svg")
  }), React.createElement("p", {
    className: "margin-top-2 margin-bottom-3"
  }, overviewText[productName] || overviewText.default), React.createElement("span", {
    className: "pg_tipsen_game_guide__number margin-bottom-2"
  }, shouldShowDrawManager ? 5 : 4), React.createElement("h4", {
    className: "margin-bottom-1 pg_tipsen_game_guide__img_header"
  }, "Har du valt resultat i alla matcher?"), React.createElement("img", {
    alt: "Betalaknapp f\xF6r spelet",
    src: "".concat(cdn, "/images/tipsen/game-guide-tipsen/").concat(productImgName, "-betslip.svg")
  }), React.createElement("p", {
    className: "margin-top-2 margin-bottom-3"
  }, "N\xE4r du valt alternativ i alla matcher dyker betalknappen upp.")));
};
setGlobal('svs.components.tipsen.gameGuideTipsen.TipsenPlay', TipsenPlay);

 })(window);